var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_loading),expression:"show_loading"}]},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loader-box"},[_c('img',{staticClass:"loader",attrs:{"src":require("@/assets/img/loader/verde.svg")}}),_c('img',{staticClass:"loader",attrs:{"src":require("@/assets/img/loader/azul.svg")}})])])
}]

export { render, staticRenderFns }